import React from "react";
import IDataFilterDescriptor from "./IDataFilterDescriptor";
import { DataFilterComponentsMapper } from "./dataFilterComponentsMapper";
import IDataFilterProps from "./IDataFilterProps";
import IExternalFilterData from "./IExternalFilterData";

interface Props {
  descriptors: IDataFilterDescriptor[];
  setDescriptors: React.Dispatch<React.SetStateAction<IDataFilterDescriptor[]>>;
  noDescriptorsLabel?: string;
  externalData?: IExternalFilterData<any>[]; // Data pro parametry mimo JSON definici
  applyButtonOnClick: () => void;
  resetButtonOnClick: () => void;
}

const DataFilter = (
  props: Props = {
    descriptors: [],
    setDescriptors: () => {},
    noDescriptorsLabel: "Filter není definován",
    applyButtonOnClick: () => {},
    resetButtonOnClick: () => {},
  }
) => {
  // FUNCTIONS
  const renderFilter = (): JSX.Element => {
    if (props.descriptors.length === 0) return <>{props.noDescriptorsLabel}</>;

    const filterElements: JSX.Element[] = [];
    props.descriptors.forEach((descriptor, index) => {
      const componentProps: IDataFilterProps = {
        filterDescriptor: descriptor,
        descriptors: props.descriptors,
        setDescriptors: props.setDescriptors,
        externalData: props.externalData,
        reactKey: index,
      };

      const element: JSX.Element | null =
        DataFilterComponentsMapper[descriptor.userInputType](componentProps) ||
        null;
      if (element)
        filterElements.push(<React.Fragment key={index} children={element} />);
    });

    return <>{filterElements}</>;
  };

  /*   const renderButtons = () => {
    return (
      <button className="btn btn-primary" onClick={props.applyButtonOnClick}>
        Filtrovat
      </button>
    );
  }; */

  return (
    <>
      <div>{renderFilter()}</div>
      {/* {renderButtons()} */}
    </>
  );
};

export default DataFilter;
